import { render, staticRenderFns } from "./schedule.page.vue?vue&type=template&id=fefeedc6&scoped=true"
import script from "./schedule.page.vue?vue&type=script&lang=ts"
export * from "./schedule.page.vue?vue&type=script&lang=ts"
import style0 from "./schedule.page.vue?vue&type=style&index=0&id=fefeedc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefeedc6",
  null
  
)

export default component.exports